import React from "react";
import { Questions, Team } from "../utils/types";
import TeamRow from "./TeamRow";

export default function QuestionView({
  question,
  teams,
  updateTeams
}: {
  question: Questions;
  updateTeams:Function;
  teams: Team[];
}) {
  return (
    <section className="question-view">
      <table >
        <thead>
          <tr className="title">
            <th>{question.value}</th>
            <th>Answer</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          {teams.map((team) => (<TeamRow key={team.id} updateTeams={updateTeams} team={team} question={question}/>
          ))}
        </tbody>
      </table>
    </section>
  );
}
